// extracted by mini-css-extract-plugin
module.exports = {"l1e3k5zw":"l1e3k5zw","b4xggkn":"b4xggkn"};